import { PlanBenefitVariantTypes } from '@/components/PlanBenefitTile/planBenefitTypes';

export const PlanIcon = ({ variant }: { variant: PlanBenefitVariantTypes }) => {
  switch (variant) {
    case 'color':
      return (
        <svg
          width="16"
          height="21"
          viewBox="0 0 16 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.1463 6.51022V15.3487H0.878069L0.896653 2.61367C0.896653 1.75104 1.59667 1.05103 2.4593 1.05103H10.477C10.954 1.05103 11.4 1.26784 11.6958 1.64263L14.8025 5.53453C15.0255 5.81175 15.1463 6.15556 15.1463 6.51177V6.51022Z"
            fill="white"
          />
          <path
            d="M15.447 15.6502H0.570143L0.594922 2.61318C0.594922 1.58639 1.43277 0.748535 2.45802 0.748535H10.4757C11.0487 0.748535 11.5799 1.00872 11.9299 1.45475L15.0366 5.34665C15.3014 5.67187 15.447 6.08848 15.447 6.51127V15.6517V15.6502ZM1.17878 15.0462H14.843V6.50973C14.843 6.22631 14.747 5.9429 14.5658 5.71988L11.4591 1.82798C11.2175 1.52599 10.8613 1.35098 10.4757 1.35098H2.45802C1.7642 1.35098 1.19737 1.91781 1.19737 2.61163L1.17878 15.0462Z"
            fill="#27282E"
          />
          <path
            d="M15.1465 15.3496V18.8853C15.1465 19.7479 14.4402 20.448 13.5776 20.448H2.43466C1.57203 20.448 0.872019 19.7479 0.872019 18.8791V15.3496H15.1465Z"
            fill="#D22A90"
          />
          <path
            d="M13.5777 20.7495H2.43479C1.40954 20.7495 0.570143 19.9116 0.570143 18.8786V15.0471H15.447V18.8848C15.447 19.9101 14.6092 20.7495 13.5762 20.7495H13.5777ZM1.17878 15.6511V18.8786C1.17878 19.5786 1.73942 20.1455 2.43324 20.1455H13.5762C14.2762 20.1455 14.843 19.5786 14.843 18.8848V15.6511H1.17878Z"
            fill="#27282E"
          />
          <path
            d="M5.82338 15.5232H5.21939V20.4032H5.82338V15.5232Z"
            fill="#27282E"
          />
          <path
            d="M3.32065 15.5232H2.71665V20.4032H3.32065V15.5232Z"
            fill="#27282E"
          />
          <path
            d="M8.38177 15.6128H7.77778V20.4029H8.38177V15.6128Z"
            fill="#27282E"
          />
          <path
            d="M10.9093 15.6128H10.3053V20.4029H10.9093V15.6128Z"
            fill="#27282E"
          />
          <path
            d="M13.3951 15.5354H12.7911V20.3256H13.3951V15.5354Z"
            fill="#27282E"
          />
          <path
            d="M5.72117 11.137C5.21474 10.5826 4.95456 9.78035 4.94836 8.72413C4.94836 8.19292 5.03819 7.67411 5.21939 7.18007C5.40058 6.68603 5.71962 6.26323 6.19043 5.92562C6.65504 5.588 7.29465 5.41919 8.10927 5.41919C8.68229 5.41919 9.16549 5.5214 9.5697 5.72738C9.97392 5.93181 10.2759 6.20438 10.4741 6.5482C10.6739 6.89201 10.7761 7.2668 10.7761 7.67566C10.7761 8.02566 10.7219 8.34005 10.6135 8.61727C10.5345 8.81705 10.2821 8.96108 9.86551 9.0633C9.44271 9.15932 9.00288 9.21352 8.54446 9.21352C8.18826 9.21352 7.81502 9.19494 7.43404 9.15932C7.04841 9.1237 6.765 9.08033 6.57141 9.03852C6.60083 10.1427 7.11965 10.691 8.12786 10.6848C8.42986 10.6786 8.70707 10.6306 8.9719 10.5454C9.23673 10.4602 9.50311 10.3518 9.77413 10.214C9.84692 10.1846 9.91352 10.1536 9.97856 10.1242C10.039 10.0947 10.087 10.0823 10.1288 10.0823C10.2248 10.0823 10.3162 10.1242 10.4122 10.2031C10.5082 10.2821 10.581 10.3843 10.6414 10.5113C10.7374 10.6863 10.7684 10.849 10.7374 11.0007C10.708 11.151 10.598 11.2903 10.4122 11.4111C10.056 11.6218 9.6936 11.7797 9.33895 11.8696C8.98274 11.9656 8.57234 12.0089 8.11392 12.0027C7.04067 11.9904 6.24928 11.7007 5.74285 11.1463L5.71807 11.1401L5.72117 11.137ZM7.35505 8.27191C7.74688 8.30133 8.14489 8.31372 8.53826 8.29669C8.93009 8.2781 9.20731 8.23009 9.37147 8.1573C9.40089 7.6865 9.29868 7.33029 9.06328 7.08405C8.82787 6.83626 8.50264 6.70926 8.08604 6.70926C7.79643 6.70926 7.54864 6.75108 7.34421 6.83626C7.13978 6.92144 6.97562 7.06547 6.84398 7.27609C6.71079 7.48052 6.62716 7.77632 6.58999 8.14491C6.6984 8.19292 6.95239 8.23474 7.34421 8.27191H7.3566H7.35505Z"
            fill="#D22A90"
          />
        </svg>
      );
    case 'grey':
      return (
        <svg
          width="16"
          height="20"
          viewBox="0 0 16 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.4471 14.9002H0.57019L0.59497 1.86318C0.59497 0.836386 1.43282 -0.00146484 2.45806 -0.00146484H10.4757C11.0487 -0.00146484 11.5799 0.258718 11.93 0.704745L15.0367 4.59665C15.3015 4.92187 15.4471 5.33848 15.4471 5.76127V14.9017V14.9002ZM1.17883 14.2962H14.8431V5.75973C14.8431 5.47631 14.7471 5.1929 14.5659 4.96988L11.4591 1.07798C11.2176 0.775986 10.8613 0.600982 10.4757 0.600982H2.45806C1.76424 0.600982 1.19742 1.16781 1.19742 1.86163L1.17883 14.2962Z"
            fill="#27282E"
          />
          <path
            d="M15.1465 14.5996V18.1353C15.1465 18.9979 14.4403 19.698 13.5777 19.698H2.43472C1.57209 19.698 0.87207 18.9979 0.87207 18.1291V14.5996H15.1465Z"
            fill="#424242"
          />
          <path
            d="M13.5778 19.9995H2.43483C1.40959 19.9995 0.57019 19.1616 0.57019 18.1286V14.2971H15.4471V18.1348C15.4471 19.1601 14.6092 19.9995 13.5762 19.9995H13.5778ZM1.17883 14.9011V18.1286C1.17883 18.8286 1.73946 19.3955 2.43328 19.3955H13.5762C14.2762 19.3955 14.8431 18.8286 14.8431 18.1348V14.9011H1.17883Z"
            fill="#27282E"
          />
          <path
            d="M5.82342 14.7732H5.21942V19.6532H5.82342V14.7732Z"
            fill="#27282E"
          />
          <path
            d="M3.32067 14.7732H2.71667V19.6532H3.32067V14.7732Z"
            fill="#27282E"
          />
          <path
            d="M8.38183 14.8628H7.77783V19.6529H8.38183V14.8628Z"
            fill="#27282E"
          />
          <path
            d="M10.9094 14.8628H10.3054V19.6529H10.9094V14.8628Z"
            fill="#27282E"
          />
          <path
            d="M13.3951 14.7854H12.7911V19.5756H13.3951V14.7854Z"
            fill="#27282E"
          />
          <path
            d="M5.72123 10.387C5.2148 9.83258 4.95462 9.03035 4.94843 7.97413C4.94843 7.44292 5.03825 6.92411 5.21945 6.43007C5.40065 5.93603 5.71968 5.51323 6.19049 5.17562C6.6551 4.838 7.29472 4.66919 8.10934 4.66919C8.68236 4.66919 9.16555 4.7714 9.56977 4.97738C9.97398 5.18181 10.276 5.45438 10.4742 5.7982C10.674 6.14201 10.7762 6.5168 10.7762 6.92566C10.7762 7.27566 10.722 7.59005 10.6136 7.86727C10.5346 8.06705 10.2822 8.21108 9.86557 8.3133C9.44277 8.40932 9.00294 8.46352 8.54452 8.46352C8.18832 8.46352 7.81508 8.44494 7.4341 8.40932C7.04847 8.3737 6.76506 8.33033 6.57147 8.28852C6.6009 9.39275 7.11971 9.94099 8.12792 9.93479C8.42992 9.9286 8.70714 9.88059 8.97197 9.79541C9.23679 9.71023 9.50317 9.60182 9.7742 9.46399C9.84698 9.43456 9.91358 9.40359 9.97862 9.37416C10.039 9.34474 10.087 9.33235 10.1288 9.33235C10.2249 9.33235 10.3162 9.37416 10.4123 9.45315C10.5083 9.53213 10.5811 9.63434 10.6415 9.76134C10.7375 9.93634 10.7685 10.099 10.7375 10.2507C10.7081 10.401 10.5981 10.5403 10.4123 10.6611C10.0561 10.8718 9.69366 11.0297 9.33901 11.1196C8.98281 11.2156 8.5724 11.2589 8.11398 11.2527C7.04073 11.2404 6.24934 10.9507 5.74291 10.3963L5.71813 10.3901L5.72123 10.387ZM7.35512 7.52191C7.74694 7.55133 8.14496 7.56372 8.53833 7.54669C8.93015 7.5281 9.20737 7.48009 9.37153 7.4073C9.40096 6.9365 9.29874 6.58029 9.06334 6.33405C8.82794 6.08626 8.50271 5.95926 8.08611 5.95926C7.7965 5.95926 7.5487 6.00108 7.34427 6.08626C7.13985 6.17144 6.97568 6.31547 6.84404 6.52609C6.71085 6.73052 6.62722 7.02632 6.59005 7.39491C6.69846 7.44292 6.95245 7.48474 7.34427 7.52191H7.35666H7.35512Z"
            fill="#424242"
          />
        </svg>
      );
  }
};
